import FourOhFour from '../templates/404';

export default FourOhFour;
